import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import PropTypes from '../../types';
import { Form } from 'react-final-form';
import AccountTurnoverDetails from './components/AccountTurnoverDetails';
import PaymentType from './components/PaymentType';
import AccountPaymentMade from './components/AccountPaymentMade';
import PaymentCredited from './components/PaymentCredited';
import PaymentTransfer from './components/PaymentTransfer';
import Submit from '../../components/Submit';
import { Content } from '../../infrastructure/content';
import CountrySelect from './components/CountrySelect';
import { filterAccountDetailsData } from './components/filterAccountDetailsData';
import { SEND_PAYMENTS, RECEIVE_PAYMENTS } from '../../utils/constants';
import { PAYMENT_TRANSFER, removeFormValues } from './accoundDetailsUtil';
class AccountDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendPayments: [],
      receivePayments: [],
      isPristine: true
    };
    this.onCountryChange = this.onCountryChange.bind(this);
    this.getPaymentsFromProps = this.getPaymentsFromProps.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  getSelectedCountries(payment) {
    const payments = this.props.getBusinessData ? this.props.getBusinessData[payment] : [];
    return payments && payments.length > 0 ? payments.map(country => Object.keys(country)[0]) : [];
  }
  onCountryChange(data, isRemoved, values) {
    if (data.type === SEND_PAYMENTS) {
      this.setState({
        sendPayments: data.list,
        receivePayments: this.getPaymentsFromProps('receive_payments', this.state.receivePayments)
      });
      values.send_payments = values.send_payments
        ? values.send_payments.filter(payment =>
            data.list.find(vv => vv === Object.keys(payment)[0])
          )
        : [];
    } else if (data.type === RECEIVE_PAYMENTS) {
      this.setState({
        receivePayments: data.list,
        sendPayments: this.getPaymentsFromProps('send_payments', this.state.sendPayments)
      });
      values.receive_payments = values.receive_payments
        ? values.receive_payments.filter(payment =>
            data.list.find(vv => vv === Object.keys(payment)[0])
          )
        : [];
    }
    if (
      isRemoved &&
      this.props.getBusinessData &&
      Object.values(this.props.getBusinessData).join('')
    ) {
      this.props.onCountryRemove(values);
    }
  }
  getPaymentsFromProps(type, stateData) {
    return stateData && stateData.length > 0
      ? stateData
      : this.props.getBusinessData && this.props.getBusinessData[type]
      ? this.props.getBusinessData[type]
      : [];
  }
  onSubmit() {
    this.setState({ ...this.state, isPristine: false });
  }
  render() {
    const { saveAboutYourForm, getBusinessData, reviewFlag, onAccountDetailsChange } = this.props;
    return (
      <div>
        <Form
          initialValues={getBusinessData}
          onSubmit={values => {
            saveAboutYourForm(filterAccountDetailsData(values, this.state));
          }}
          render={({ handleSubmit, values, pristine }) => {
            removeFormValues(values, this);
            return (
              <form onSubmit={handleSubmit}>
                <div>
                  <Content>
                    {({
                      accountDetailsPageTitle = '',
                      accountDetailsSendMoney,
                      accountDetailsSupplyMoney,
                      accountDetailsCheckBoxMakePaymentSub,
                      accountDetailsCheckBoxReceivePaymentSub,
                      internationalPaymentsErrors,
                      accountDetailCountrySelectionError,
                      percentFieldValidation,
                      accountDetailsSendMoneyHelpText,
                      accountDetailsReceiveMoneyHelpText,
                      whatPercentAnnualOutgoingText,
                      whatPercentAnnualOutgoingHelpText,
                      whatPercentAnnualEstimatedText,
                      whatPercentAnnualEstimatedHelpText
                    }) => (
                      <div>
                        {reviewFlag ? '' : <PageHeading>{accountDetailsPageTitle}</PageHeading>}
                        <AccountTurnoverDetails />
                        <PaymentType values={values} pristine={pristine} />
                        <AccountPaymentMade />
                        <PaymentTransfer
                          values={values}
                          onChange={selectedId =>
                            getBusinessData &&
                            Object.values(getBusinessData).join('') &&
                            onAccountDetailsChange({ target: { value: selectedId } })
                          }
                        />
                        {values && values.accountDetailsPayment === PAYMENT_TRANSFER.MAKE_PAYMENTS && (
                          <CountrySelect
                            id="turnoverCustomers"
                            name="send_payments"
                            placeholder={accountDetailsCheckBoxMakePaymentSub}
                            label={accountDetailsSendMoney}
                            accordionLabel={accountDetailsCheckBoxMakePaymentSub}
                            fieldValidation={internationalPaymentsErrors}
                            isPristine={this.state.isPristine}
                            formValues={values.send_payments}
                            percentFieldValidation={percentFieldValidation}
                            onAccountDetailsValueChange={(v, isRemoved) => {
                              this.onCountryChange({ list: v, type: 'send' }, isRemoved, values);
                            }}
                            getSelectedCountries={this.getSelectedCountries('send_payments')}
                            helpText={accountDetailsSendMoneyHelpText}
                            whatPercentAnnualOutgoingText={whatPercentAnnualOutgoingText}
                            whatPercentAnnualOutgoingHelpText={whatPercentAnnualOutgoingHelpText}
                          />
                        )}
                        {values &&
                          values.accountDetailsPayment === PAYMENT_TRANSFER.RECEIVE_PAYMENTS && (
                            <CountrySelect
                              id="turnoverSuppliers"
                              name="receive_payments"
                              placeholder={accountDetailsCheckBoxReceivePaymentSub}
                              label={accountDetailsSupplyMoney}
                              accordionLabel={accountDetailsCheckBoxReceivePaymentSub}
                              fieldValidation={accountDetailCountrySelectionError}
                              formValues={values.receive_payments}
                              onAccountDetailsValueChange={(v, isRemoved) => {
                                this.onCountryChange(
                                  { list: v, type: 'receive' },
                                  isRemoved,
                                  values
                                );
                              }}
                              isPristine={this.state.isPristine}
                              percentFieldValidation={percentFieldValidation}
                              getSelectedCountries={this.getSelectedCountries('receive_payments')}
                              helpText={accountDetailsReceiveMoneyHelpText}
                              whatPercentAnnualOutgoingText={whatPercentAnnualEstimatedText}
                              whatPercentAnnualOutgoingHelpText={whatPercentAnnualEstimatedHelpText}
                            />
                          )}
                        {values &&
                          values.accountDetailsPayment ===
                            PAYMENT_TRANSFER.MAKE_AND_RECEIVE_PAYMENTS && (
                            <div>
                              <CountrySelect
                                id="turnoverCustomers"
                                name="send_payments"
                                placeholder={accountDetailsCheckBoxMakePaymentSub}
                                label={accountDetailsSendMoney}
                                accordionLabel={accountDetailsCheckBoxMakePaymentSub}
                                fieldValidation={internationalPaymentsErrors}
                                isPristine={this.state.isPristine}
                                percentFieldValidation={percentFieldValidation}
                                formValues={values.send_payments}
                                onAccountDetailsValueChange={(v, isRemoved) => {
                                  this.onCountryChange(
                                    { list: v, type: 'send' },
                                    isRemoved,
                                    values
                                  );
                                }}
                                getSelectedCountries={this.getSelectedCountries('send_payments')}
                                helpText={accountDetailsSendMoneyHelpText}
                                whatPercentAnnualOutgoingText={whatPercentAnnualOutgoingText}
                                whatPercentAnnualOutgoingHelpText={
                                  whatPercentAnnualOutgoingHelpText
                                }
                              />
                              <CountrySelect
                                id="turnoverSuppliers"
                                name="receive_payments"
                                placeholder={accountDetailsCheckBoxReceivePaymentSub}
                                label={accountDetailsSupplyMoney}
                                accordionLabel={accountDetailsCheckBoxReceivePaymentSub}
                                fieldValidation={accountDetailCountrySelectionError}
                                formValues={values.receive_payments}
                                onAccountDetailsValueChange={(v, isRemoved) => {
                                  this.onCountryChange(
                                    { list: v, type: 'receive' },
                                    isRemoved,
                                    values
                                  );
                                }}
                                isPristine={this.state.isPristine}
                                percentFieldValidation={percentFieldValidation}
                                getSelectedCountries={this.getSelectedCountries('receive_payments')}
                                helpText={accountDetailsReceiveMoneyHelpText}
                                whatPercentAnnualOutgoingText={whatPercentAnnualEstimatedText}
                                whatPercentAnnualOutgoingHelpText={
                                  whatPercentAnnualEstimatedHelpText
                                }
                              />
                            </div>
                          )}
                        <PaymentCredited values={values} />
                        <Submit onClick={this.onSubmit} />
                      </div>
                    )}
                  </Content>
                </div>
              </form>
            );
          }}
        />
      </div>
    );
  }
}
AccountDetailsPage.propTypes = {
  saveAboutYourForm: PropTypes.func.isRequired,
  getBusinessData: PropTypes.func
};
export default AccountDetailsPage;
